import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import * as _ from 'lodash'
@Component({
  selector: 'app-confirm-status',
  templateUrl: './confirm-status.component.html',
  styleUrls: ['./confirm-status.component.scss']
})
export class ConfirmStatusComponent implements OnInit {
  selectStatus
  displayError = false
  constructor(public _snackbar: MatSnackBar, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
    public _portfolioService: PortfolioService) { }

  ngOnInit() {
    console.log('this.data', this.data)
  }

  confirm(confirmation) {
    console.log('confirmation', confirmation)
    console.log("what is total data", this.data);
    console.log("selected status value", this.selectStatus);

    if (confirmation == 'yes') {

      if (this.selectStatus == undefined) {
        this.displayError = true
      } else {
  

        _.forEach(this.data, (singleData) => {
          singleData['status'] = this.selectStatus
        })
        console.log("what is the final array to send ", this.data);
        this._portfolioService.changeUnitStatus(this.data).subscribe(res => {
          console.log("res in modal", res)
          this.dialogRef.close({ data: res.data, type: 'yes' })
        })
      }
    }
    else {
      this.dialogRef.close({ type: 'no' })
    }
  }

}
